import { render, staticRenderFns } from "./StatsMarketing.vue?vue&type=template&id=62bf299a&scoped=true"
import script from "./StatsMarketing.vue?vue&type=script&lang=js"
export * from "./StatsMarketing.vue?vue&type=script&lang=js"
import style0 from "./StatsMarketing.vue?vue&type=style&index=0&id=62bf299a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bf299a",
  null
  
)

export default component.exports